import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=36271904&scoped=true&"
import script from "./LoadingPage.vue?vue&type=script&lang=js&"
export * from "./LoadingPage.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=36271904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36271904",
  null
  
)

export default component.exports